'use strict';

    angular
        .module('app.influencerGroupInfluencerList', [])
        .directive('influencerGroupInfluencerListDirective', function () {
        return {
            controller: 'influencerGroupInfluencerListCtrl',
            templateUrl: 'app/influencerGroup/influencerGroupInfluencerList/influencerGroupInfluencerList.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                influencerGroupId: "="
            },
            replace: true,
            transclude: true
        };
    })

    .directive('influencerInfoPopover', function($timeout, $compile){
        var linker = function (scope, element, attrs) {
            var content = $compile(element.data('content-compile'))(scope);
            $timeout(function() {
                element.popover({
                    'html': true,
                    'content': content,
                    'template': '<div style="width: 212px; height: 114px; border: none; border-radius: 0; background-color: #dce3e8; margin-left: -12px;" class="popover" role="tooltip">' +
                            '<div class="arrow popover-arrow"></div>' +
                            '<h3 class="popover-title"></h3>' +
                            '<div class="popover-content" style="padding: 0px;"></div>' +
                            '</div>'
                }).on("show.bs.popover", function(e){
                        $("[rel=popover]").not(e.target).popover("destroy");
                        $(".popover").remove();
                    });
            }, 400);
        }
        return {
            restrict: 'AE',
            link: linker
        }
    })

